import { Directive, HostBinding, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({ selector: '[appDragDrop]' })
export class DragDropDirective {
  @Output() fileDropped = new EventEmitter<FileList>();

  @HostBinding('class.dragover') public useDragOver = false;

  constructor() { }

  // Dragover listener
  @HostListener('dragover', ['$event']) onDragOver(ev: DragEvent): void {
    ev.preventDefault();
    ev.stopPropagation();
    this.useDragOver = true;
  }

  // Dragleave listener
  @HostListener('dragleave', ['$event']) public onDragLeave(ev: DragEvent): void {
    ev.preventDefault();
    ev.stopPropagation();
    this.useDragOver = false;
  }

  // Drop listener
  @HostListener('drop', ['$event']) public ondrop(ev: DragEvent): void {
    ev.preventDefault();
    ev.stopPropagation();
    this.useDragOver = false;

    const files = ev.dataTransfer.files;
    if (files.length > 0) {
      this.fileDropped.emit(files);
    }
  }
}
